module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-ons-navigator', {
    attrs: {
      "page-stack": _vm.pageStack,
      "options": _vm.options
    }
  }), _vm._v(" "), _c('load-progress')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-11c7642e","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/app_navigator.vue
// module id = 918
// module chunks = 0